import type { ReactNode } from "react";
import FinanceHelpLabel from "./FinanceHelpLabel";

interface FinanceMetricCardProps {
  label: string;
  value: ReactNode;
  comparison?: string | null;
  incomplete?: boolean;
}

export default function FinanceMetricCard({
  label,
  value,
  comparison,
  incomplete = false,
}: FinanceMetricCardProps) {
  return (
    <article className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <p className="text-sm font-medium text-slate-600">
        <FinanceHelpLabel label={label} />
      </p>
      <p className="mt-2 text-2xl font-semibold text-slate-900">{value}</p>
      {comparison && (
        <p className="mt-2 text-sm text-slate-500">{comparison}</p>
      )}
      {incomplete && (
        <p className="mt-2 text-xs font-medium text-amber-700">
          Incomplete source data
        </p>
      )}
    </article>
  );
}
